const toArray = (value) => {
  if (Array.isArray(value)) return value;
  if (Array.isArray(value?.results)) return value.results;
  return [];
};

const toNumber = (value) => {
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : 0;
};

export const formatStockCountNumber = (value, decimals = 3) => {
  const parsed = Number(value);
  if (!Number.isFinite(parsed)) return "0";
  const rounded = Number(parsed.toFixed(decimals));
  if (Number.isInteger(rounded)) return String(rounded);
  return rounded.toFixed(decimals).replace(/\.?0+$/, "");
};

export const getStockCountPresentationsFromItem = (item) => {
  const available = toArray(item?.available_presentations).map((presentation) => ({
    id: presentation?.id,
    format_name: presentation?.format_name || presentation?.name,
    qty_in_base: presentation?.qty_in_base,
  }));

  const current = item?.product_presentation
    ? [
        {
          id: item.product_presentation.id,
          format_name: item.product_presentation?.product_format?.name,
          qty_in_base: item.product_presentation?.qty_in_base,
        },
      ]
    : [];

  return [...available, ...current];
};

export const formatStockCountReadableQty = (qtyBase, productPresentations = [], options = {}) => {
  const rawQtyBase = toNumber(qtyBase);
  const sign = rawQtyBase < 0 ? "-" : options.showPlus && rawQtyBase > 0 ? "+" : "";
  const safeQtyBase = Math.abs(rawQtyBase);

  const presentations = Array.from(
    new Map(
      toArray(productPresentations)
        .map((presentation) => {
          const qtyInBase = toNumber(presentation?.qty_in_base);
          const label =
            presentation?.format_name ||
            presentation?.name ||
            presentation?.product_format?.name ||
            presentation?.label ||
            "unidad";
          if (!Number.isFinite(qtyInBase) || qtyInBase <= 0) return null;
          return [`${qtyInBase}:${label}`, { qty_in_base: qtyInBase, label }];
        })
        .filter(Boolean)
    ).values()
  ).sort((left, right) => right.qty_in_base - left.qty_in_base);

  if (presentations.length === 0) {
    return `${sign}${formatStockCountNumber(safeQtyBase)} unidades`;
  }

  if (safeQtyBase <= 0.000001) {
    const minPresentation = presentations[presentations.length - 1];
    return `0 ${minPresentation.label}`;
  }

  let remainder = safeQtyBase;
  const parts = [];

  presentations.forEach((presentation, index) => {
    const isLast = index === presentations.length - 1;
    let units = 0;
    if (isLast) {
      units = remainder / presentation.qty_in_base;
    } else {
      units = Math.floor((remainder + 0.000001) / presentation.qty_in_base);
      remainder -= units * presentation.qty_in_base;
    }
    if (units > 0.000001) {
      parts.push(`${formatStockCountNumber(units)} ${presentation.label}`);
    }
  });

  if (parts.length === 0) {
    const minPresentation = presentations[presentations.length - 1];
    return `0 ${minPresentation.label}`;
  }

  return `${sign}${parts.join(" y ")}`;
};
